import { RedoFulfillmentToteSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote";
import * as z from "zod/v4";

export const getTotesByIds = {
  name: "getTotesByIds" as const,
  input: z.object({
    toteIds: z.array(z.string()),
  }),
  output: z.object({
    totes: z.array(RedoFulfillmentToteSchema),
  }),
};
